import React from 'react'
import AddService from '../conponents/operate/add-services/add-service'

export const AddServicePage = () => <AddService/>